import angular from 'angular'
import stampDutyreportQuery from './stampDutyreportQuery'
import stampDutyTaskTracking from './stampDutyTaskTracking'

export default angular
  .module('declaration.stampDuty', [
    stampDutyreportQuery,
    stampDutyTaskTracking,
  ])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      $stateProvider.state('declaration.stampDuty', {
        abstract: true,
        url: '/stampDuty',
        template: '<div ui-view></div>',
        title: '印花税',
      })
    },
  ]).name



// WEBPACK FOOTER //
// ./src/app/declaration/stampDuty/index.js